import actions from "./actions";
import mutations from "./mutations";
import state from "./state";

const getters = {
  getTeacherAwayApplicationApprovalList: (state) => state.items,
  getTeacherAwayApplicationApprovalPagination: (state) => state.pagination,
  setTeacherAwayApplicationApprovalPage: (state) =>
    state.pagination.current_page,
  setTeacherAwayApplicationApprovalBusy: (state) => state.isBusy,
};

export default {
  actions,
  mutations,
  getters,
  state,
};
